import { browserHistory } from 'common/utils/browserHistory';
import {
  SEARCH_PATH,
} from '../constants';

export default function goToSearchStep({ context }) {
  browserHistory.push(`/${context}/${SEARCH_PATH}`);
}
